import { authorCourse, terrainPreset, type HolePlan } from './courseAuthoring';
import { plans } from './coursePlans';
export const blackOakReserveMetadata = {
  id: 'black-oak-reserve',
  name: 'Black Oak Reserve',
  description:
    'A warm woodland reserve with broad angled fairways, large sloping greens and recurring creek decisions.',
  environmentPreset: 'autumn-woodland',
  metadata: {
    location: 'Blue Ridge, Virginia',
    regionType: 'elevated oak reserve',
    difficulty: 80,
    typicalWind: [4, 15] as const,
    greenSpeed: [10, 11] as const,
    firmness: 'medium-soft' as const,
    primaryChallenge: 'Approach angles, creek placement, tree-line shaping and elevation recovery',
    signatureHoles: [5, 9, 14, 18],
    tournamentEventId: 'event-11',
    previewTheme: 'autumn-black-oak',
    environmentPalette: {
      fairway: '#627746',
      rough: '#704d32',
      bunker: '#bd9c69',
      water: '#456f68',
      haze: '#c08b63',
    },
    vegetationStyle: 'large black oak with warm autumn understory',
    terrainStyle: terrainPreset('oak-ridges', 20, 135, 1.15).id,
  },
};
const pars = [4, 4, 5, 3, 4, 5, 4, 3, 4, 4, 5, 3, 4, 4, 3, 5, 4, 4];
const yards = [
  425, 410, 555, 180, 445, 520, 400, 205, 430, 450, 560, 165, 420, 455, 195, 535, 415, 470,
];
const names = [
  'Acorn',
  'Reserve Line',
  'Creek Fork',
  'Canopy',
  'Angle Oak',
  'Upper Ridge',
  'Warm Hollow',
  'Fallen Leaf',
  'Crossing',
  'Old Growth',
  'Broad Run',
  'Copper Leaves',
  'Sidehill',
  'Creek Choice',
  'Black Oak',
  'High Branch',
  'Last Grove',
  'Reserve Home',
];
const options: Partial<HolePlan>[] = [];
options[4] = {
  water: 'left',
  landingZones: [{ distance: 275, width: 58, preferredSide: 'right' }],
  greenRadius: 21,
};
options[8] = { water: 'carry', greenRadius: 20 };
options[13] = {
  water: 'right',
  landingZones: [{ distance: 270, width: 60, preferredSide: 'left' }],
};
options[17] = { water: 'green', greenRadius: 22 };
export const createBlackOakReserveDocument = () =>
  authorCourse({
    ...blackOakReserveMetadata,
    plans: plans(names, pars, yards, options).map((p) => ({
      ...p,
      trees: p.trees ?? 6,
      greenRadius: p.greenRadius ?? 20,
      landingZones: p.landingZones?.map((z) => ({ ...z, width: Math.max(52, z.width) })),
    })),
  });
